import React from "react";
import Carousal from "./Carousal";
import MobileCarousal from "./MobileCarousal";

const CategoryPageCarousal = ({ SubCategoryBanners, SkeletonLoad }) => {
  return (
    <div className="site-container error-message">
      <div className="mt-1 hidden md:block">
        <div className="w-full">
          <Carousal
            SubCategoryBanners={SubCategoryBanners}
            SkeletonLoad={SkeletonLoad}
            SwiperClassName="w-full"
          />
        </div>
      </div>
      <div className="block md:hidden">
        <MobileCarousal
          SubCategoryBanners={SubCategoryBanners}
          SkeletonLoad={SkeletonLoad}
        />
      </div>
    </div>
  );
};

export default CategoryPageCarousal;
